import React from 'react'
import bgImg from '../img/BG.svg'
import MobileHeroBg from '../img/MapMobile.svg'
import dots from '../img/dotsN.svg'
import map from '../img/abUs005.svg'
import COLORS from '../constants/colors';


const AboutFive = () => {
  return (
    <>
      {/* Desktop/Laptop/Tablet Section */}
      <section className="hidden sm:flex relative items-center justify-between overflow-hidden
        h-[33.19vh]
        md:h-[300px]
        lg:h-[320px]
        xl:h-[500px]
        2xl:h-[574px]
        min-[3840px]:h-[956px]">
        <img
          src={bgImg}
          alt="Hero Background"
          className="absolute inset-0 w-full h-full z-0"
        />

        {/* Text Block - Positioned at 45% mark (start of right 55%) */}
        <div className="absolute left-[45%] top-1/2 -translate-y-1/2 z-10
    pr-[20px]
    md:pr-[30px]
    lg:pr-[40px]
    xl:pr-[50px]
    2xl:pr-[60px]
    min-[3840px]:pr-[100px]
    ">

          {/* Heading */}
          <h1 className="mb-2 font-[Quicksand] font-bold text-[28px] leading-[35px] max-w-[85vw] md:text-[32px] md:leading-[38px] md:max-w-[50vw] lg:text-[36px] lg:leading-[42px] lg:max-w-[45vw] xl:text-[48px] xl:leading-[56px] xl:max-w-[568px] 2xl:text-[56px] 2xl:leading-[64px] 2xl:max-w-[680px] min-[3840px]:text-[72px] min-[3840px]:leading-[80px] min-[3840px]:max-w-[1136px] capitalize" style={{ color: COLORS.primaryBlue }}>
            Our <span style={{ color: COLORS.buttonColor }}>Network</span>
          </h1>

          {/* Subtext */}
          <p className="font-[Quicksand] text-[8px] leading-[8px] max-w-[318px] md:text-[10px] md:leading-[12px] md:max-w-[368px] lg:text-[12px] lg:leading-[14px] lg:max-w-[490px] xl:text-[16px] xl:leading-[22px] xl:max-w-[650px] 2xl:text-[20px] 2xl:leading-[25px] 2xl:max-w-[680px] min-[3840px]:text-[36px] min-[3840px]:leading-[40px] min-[3840px]:max-w-[1510px]" style={{ color: COLORS.gray }}>
            We partner with vetted personal injury and motor vehicle accident law firms nationwide. These firms work on a contingency basis meaning you pay nothing unless you win compensation.
          </p>
        </div>
      </section>

      {/* Mobile Hero Section */}
      <section className="flex sm:hidden relative w-full h-[568px] flex-col items-start justify-between bg-white overflow-hidden">

        {/* Dots at top-right */}
        <img
          src={dots}
          alt="Top Right Dots"
          className="absolute top-0 right-0 w-1/2 h-[42px] object-contain z-10"
        />

        {/* Text Content */}
        <div className="relative z-20 flex flex-col items-start w-full px-4 pt-[97px]">
          <h1 className="mb-4 text-left capitalize font-[Quicksand] font-bold text-[24px] leading-normal" style={{ color: COLORS.primaryBlue }}>
            Our <span style={{ color: COLORS.buttonColor }}>Network</span>
          </h1>

          <h2 className="text-left font-[Quicksand] text-[15px] leading-normal" style={{ color: COLORS.gray }}>
            We partner with vetted personal injury and motor vehicle accident law firms nationwide. These firms work on a contingency basis meaning you pay nothing unless you win compensation.
          </h2>
        </div>

        {/* Map at bottom */}
        <img
          src={map}
          alt="USA Map"
          className="
    absolute bottom-[64.53px] left-1/2 transform -translate-x-1/2
    w-[84.24%] max-w-[358px] z-10
    h-[235.186px]
    min-[375px]:h-[250px]
    min-[425px]:h-[270px]
    object-contain
  "
        />

      </section>
    </>
  )
}

export default AboutFive
